/**
 * 🟥 CUADRO NEGRO 2026-02 — Detector de intención "Proyecto en código".
 *
 * Se invoca en el flujo de envío del chat. Si el mensaje del usuario contiene
 * señales de un PROYECTO (no un snippet suelto), interceptamos y mostramos
 * el ProjectAdaptPrompt en lugar del flujo normal.
 *
 * Reglas (umbral ≥ 2 puntos):
 *   - 2 o más code-fences ```...```      → +2
 *   - 1 code-fence + mensaje > 800 chars → +1
 *   - Mención de archivos típicos        → +2  (package.json, requirements.txt, etc.)
 *   - Marcadores de archivo en código    → +2  (// file: …, # path: …)
 *
 * Sincronizada con la lógica server-side en /app/backend/routes/project_builder.py
 */

const PROJECT_FILE_MARKERS = [
  'package.json', 'tsconfig.json', 'vite.config', 'next.config',
  'requirements.txt', 'pyproject.toml', 'setup.py', 'manage.py',
  'cargo.toml', 'go.mod', 'pom.xml', 'build.gradle',
  'composer.json', 'gemfile', 'dockerfile', 'docker-compose',
];

export function detectProjectIntent(message) {
  if (!message || typeof message !== 'string') {
    return { isProject: false, score: 0, fenceCount: 0 };
  }
  const text = message;
  const lower = text.toLowerCase();

  const fenceMatches = text.match(/```[a-zA-Z0-9_+-]*\n/g) || [];
  const fenceCount = fenceMatches.length;

  const strongMarkers = PROJECT_FILE_MARKERS.filter((m) => lower.includes(m));
  const fileHints = (text.match(/^(?:\/\/|#|<!--)\s*(?:file|path|filename)\s*[:=]\s*[\w./\\-]+/gim) || []).length;

  let score = 0;
  if (fenceCount >= 2) score += 2;
  if (fenceCount >= 1 && text.length > 800) score += 1;
  if (strongMarkers.length > 0) score += 2;
  if (fileHints >= 1) score += 2;

  return {
    isProject: score >= 2,
    score,
    fenceCount,
    fileHints,
    strongMarkers,
  };
}

export default detectProjectIntent;
